import { IS_DEV } from "globals/constants";
import { isPresent } from "utils/budgetBuilder";
import { notifyError } from "utils";
import store from "store/store";
import { awardSelectors, budgetBuilderSelectors, proposalSelectors, subawardSelectors } from "store/selectors";

import {
	getDefaultLineItemsFromState,
	getPreparedPayload,
	getResearchTeamElement,
} from "./utils";
import { budgetFactory } from "./actions";
import { loadCaseInstance } from "./caseInstance";
import { collectResearchTeamDataForPeriod } from "./members";


export const loadBudgetBuilder = async (isRefresh = true, budgetType = budgetBuilderSelectors.budgetType()) => {
	const state = store.getState();

	let caseInstanceId;
	if (budgetType === null) {
		budgetType = budgetBuilderSelectors.budgetType(state);
	}
	if (budgetType === "proposal") {
		caseInstanceId = proposalSelectors.caseInstanceId(state);
	} else if (budgetType === "subaward") {
		caseInstanceId = subawardSelectors.caseInstanceId(state);
	} else {
		// this cover awards and awards modifications
		caseInstanceId = awardSelectors.caseInstanceId(state);
	}

	if (!caseInstanceId) {
		throw new Error(`'caseInstanceId' is not defined`);
	}

	return loadCaseInstance({ caseInstanceId, budgetType, isRefresh }, state);
};

export const changePeriodNumber = async newPeriodNumber => {
	const state = store.getState();
	const currentPeriodNumber = budgetBuilderSelectors.currentPeriodNumber(state);

	if ((newPeriodNumber !== 0 && !newPeriodNumber) || currentPeriodNumber === newPeriodNumber) {
		return Promise.resolve();
	}

	const periodRows = budgetBuilderSelectors.periodRows(state);
	const cachedPeopleById = budgetBuilderSelectors.cachedPeopleById(state);
	const newResearchTeam = budgetBuilderSelectors.researchTeamForPeriod(state, newPeriodNumber) || [];
	const payload = budgetBuilderSelectors.payload(state);
	const content = budgetBuilderSelectors.content(state);
	const newPeriodRate = budgetBuilderSelectors.rateForPeriod(state, newPeriodNumber) || 0;
	const externalCostShare = budgetBuilderSelectors.externalCostShareForPeriod(state, newPeriodNumber) || [];
	const internalCostShare = budgetBuilderSelectors.internalCostShareForPeriod(state, newPeriodNumber) || [];
	const unnamed = budgetBuilderSelectors.savedUnnamedMembers(state) || [];

	let sponsoredCosts = budgetBuilderSelectors.sponsoredCostsForPeriod(state, newPeriodNumber);
	if (!isPresent(sponsoredCosts)) {
		sponsoredCosts = getDefaultLineItemsFromState(newPeriodRate);
	}

	const newPayload = getPreparedPayload();
	const fromParent = getResearchTeamElement(content.budgetType, payload);

	try {
		budgetFactory.setIsFetching(true);

		const newContent = await collectResearchTeamDataForPeriod(
			newResearchTeam,
			fromParent,
			unnamed,
			cachedPeopleById,
			newPeriodNumber,
		);

		budgetFactory.setData({
			...content,
			lineItems: {
				sponsoredCosts,
				externalCostShare,
				internalCostShare,
			},
			payload: newPayload,
			currentPeriod: periodRows.find(row => row.periodNumber === newPeriodNumber),
			...newContent,
		})

	} catch (error) {
		const message = IS_DEV ? error.message : "An error occurred fetching Change period number.";

		notifyError(message, error);
		budgetFactory.setError(false);

	} finally {
		budgetFactory.setIsFetching(false);
	}
};

